import FileSaver from 'file-saver';
import { Parser } from 'json2csv';

export function ExportCSV(
  data: unknown[],
  filename: string,
  fields?: { value: string; label?: string }[]
): void {
  const downloadName = `${filename}_${new Date().toISOString()}.csv`;

  const js2CSV = new Parser({ fields });
  const parsedText = new Blob([js2CSV.parse(data)], {
    type: 'text/plain;charset=utf-8',
  });

  return FileSaver.saveAs(parsedText, downloadName);
}

export function ExportJSON(data: any, filename: string): void {
  const downloadName = `${filename}_${new Date().toISOString()}.json`;

  const parsedText = new Blob([JSON.stringify(data)], {
    type: 'application/json;charset=utf-8',
  });

  return FileSaver.saveAs(parsedText, downloadName);
}
